export default "__VITE_ASSET__BVECk8g8__"